import { DataFetchingClientProvider } from 'data-fetching-client';
import { filtersDataFetchingClient } from '../../../fetcher/DataFetchingClient';
import { PropertySearchSuggestionsComponent } from './PropertySearchSuggestionsComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertySearchSuggestions = props => {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: filtersDataFetchingClient,
    children: /*#__PURE__*/_jsx(PropertySearchSuggestionsComponent, Object.assign({}, props))
  });
};